import script from "./Permissions.vue?vue&type=script&setup=true&lang=js"
export * from "./Permissions.vue?vue&type=script&setup=true&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=e5846ccc&lang=css"

const __exports__ = script;

export default __exports__